<template>
  <Modal v-model="model" sticky reset-drag-position :title="title" @on-cancel="cancel" footer-hide scrollable :mask="false" draggable class="insert_edit_dept">
      <div class="pop_top">
        <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
        <div class="dept_edit_input" v-show="title=='添加子导航'">
          <div class="font_style_set">上级导航:</div>
          <Select v-model="higherLevelDept" :disabled="disabled">
            <Option v-for="(option, index) in higherLevelDeptList" :value="option.id" :key="index">{{option.navName}}</Option>
          </Select>
        </div>
        <div class="dept_edit_input">
          <div class="font_style_set"><span style="color: red;margin-right: 5px">*</span>导航名称:</div>
          <Input v-model="navName" :maxlength="250"/>

        </div>
        <div class="dept_edit_input">
          <div class="font_style_set">导航说明:</div>
          <Input v-model="deptDescr" type="textarea" :autosize="{minRows:3,maxRows: 100}" :maxlength="250"/>
        </div>
      </div>
      <div class="btn_template">
        <Button type="error"   class="cancel_btn" @click="cancel()">取消</Button>
        <Button type="primary" class="submit_btn" @click="save()">保存</Button>
      </div>
  </Modal>
</template>

<script>
    export default {
        name: "AddsubmenuPop",
        props: {
          showAddsubmenu:Boolean,
          higherLevelDeptList:Array,
          deptId:String,
          title:String,
          pid:String,
          journalType:String,
          menuId:String,
        },
        data(){
          return{
            model:false,
            disabled:true,
            higherLevelDept:'',
            navName:'',
            deptDescr:'',
            spinShow:false,
          }
        },
        methods:{
          cancel:function(){
            this.$emit("closeSubmenu",false);
          },
          save:function(){
            if(!this.navName||this.navName==""||this.navName==null||this.navName==" "){
              this.$Modal.info({
                title:'提示',
                content:"导航名称不能为空"
              });
              return false;
            };
            this.higherLevelDept=this.pid;
            if(this.higherLevelDept==""||this.higherLevelDept==null||!this.higherLevelDept){
                if(this.higherLevelDeptList!=null&&this.higherLevelDeptList!=''){
                  this.higherLevelDept=this.higherLevelDeptList[0].id;
                }else{
                  this.higherLevelDept="0";
                }
            }
            let param={
              id:this.deptId,
              pid:this.higherLevelDept,
              //pid:this.pid,
              navName:this.navName,
              descr:this.deptDescr,
              journalType: this.journalType,
              menuId:this.menuId,
            };
            this.spinShow = true;
            let that=this;
            this.$http.post("chatNav/doSave.json",param) .then(function (res) {
              let result=res.data.flag;
              if(result!="666"){
                that.spinShow = false;
                that.$alert(res.data.msg, '提示', {
                  confirmButtonText: '确定'
                });
                return false;
              }

              setTimeout(function () {
                that.spinShow = false;
                that.$Message.info("保存成功");
                that.$emit("closeSubmenu",true);
              }, 2000);
            });
          },
        },
        watch:{
          showAddsubmenu:function () {
            this.model=this.showAddsubmenu;
            this.navName="";
            this.deptDescr="";
            if(!this.showAddsubmenu){
              return false;
            }
            this.higherLevelDept=this.pid;
            if(this.higherLevelDept==""||this.higherLevelDept==null||!this.higherLevelDept){
                if(this.higherLevelDeptList!=null&&this.higherLevelDeptList!=''){
                  this.higherLevelDept=this.higherLevelDeptList[0].id;
                }else{
                  this.higherLevelDept="0";
                }
            }
          }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/systemSetup/DialogueConfigure/AddsubmenuPop.vue